import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  paymentInfoHeader: {
    paddingBottom: theme.spacing(2),
  },
  radioGroupContainer: {
    minHeight: '80px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  textField: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
      margin: theme.spacing(2, 0),
    },
  },
  stateTextField: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
      margin: theme.spacing(2, 0),
    },
    zIndex: 1000,
  },
  cardInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 0,
  },
  errorText: {
    color: theme.palette.error.main,
  },
  activeText: {
    color: theme.palette.text.primary,
  },
  defaultText: {
    color: theme.palette.text.secondary,
  },
  bitPayContainer: {
    [theme.breakpoints.down('xl')]: {
      marginTop: theme.spacing(1),
    },
  },
}));
